import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { encrypt } from '../crypto'
import { setUser } from '../redux/Slices/UserSlice';
import NavbarMob from '../components/NavbarMob';
import Navbar from '../components/Navbar';
import FooterMob from '../components/FooterMob';
import Footer from '../components/Footer';
import OrderSuccess from '../components/OrderSuccess';
import deleteicon from '../images/Cart/Bin.png'
import axios from 'axios'
import { useStore } from '../useStore';
import { shortEncrypt } from "../crypto";

function Cart() {
    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });
    const navigate = useNavigate();
    const [cartItems, setCartItems] = useState([]);
    const [addError, setAddError] = useState(false)

    // console.log(cartItems, 'cartItems');


    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [address, setAddress] = useState(null);
    const [productDetails, setProductDetails] = useState({}); // To store color and size for each uniqueCode
    const [orderPlaced, setOrderPlaced] = useState(false);
    const [isProcessing, setIsProcessing] = useState(false);
    const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
    const [loginEmail, setLoginEmail] = useState('');
    const [loginPassword, setLoginPassword] = useState('');
    const [loginError, setLoginError] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [rememberMe, setRememberMe] = useState(false);
    const dispatch = useDispatch();

    // console.log(address, 'address');


    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const apiLocalUrl = process.env.REACT_APP_API_LOCAL_URL;
    const apiRazorpayUrl = process.env.REACT_APP_API_SERVER_URL;
    const apiWhatsappUrl = process.env.REACT_APP_API_WHATSAPP;


    const userId = useSelector((state) => state.user.id);
    const LedCode = localStorage.getItem('LedCode');

    // Fetch product details (color and size) by uniqueCode
    const fetchProductDetails = async (uniqueCode) => {
        try {
            const response = await fetch(
                `${apiBaseUrl}/getProductByUniqueCode/BLACKBATON_2526?uniqueCode=${uniqueCode}`
            );
            if (!response.ok) {
                throw new Error('Failed to fetch product details');
            }
            const data = await response.json();
            if (data.length > 0) {
                return data[0]; // Return the first item (color and size)
            }
            return null;
        } catch (error) {
            console.error('Error fetching product details:', error);
            return null;
        }
    };

    const { showDropdown, setShowDropdown } = useStore()

    // Fetch cart items
    useEffect(() => {
        const remembered = localStorage.getItem('rememberedIdentifier');
        if (remembered) {
            setLoginEmail(remembered);
            setRememberMe(true);
        }
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);

        const fetchCartItems = async () => {
            try {
                const ledCodeOrUserId = LedCode || userId;
                let finalItems = [];

                if (!ledCodeOrUserId) {
                    // Guest User: Load from localStorage
                    const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
                    finalItems = guestCart;
                } else {
                    // Authenticated User: Fetch from DB and check for guest cart to merge
                    const response = await fetch(
                        `${apiBaseUrl}/cart/items/BLACKBATON_2526/${ledCodeOrUserId}`
                    );
                    const data = await response.json();
                    let dbItems = (data.success && data.items) ? data.items : [];

                    // Check for guest cart to merge
                    const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
                    if (guestCart.length > 0) {
                        try {
                            const currentLoginId = localStorage.getItem('loginId') || ledCodeOrUserId;
                            const currentLoginName = localStorage.getItem('loginName') || 'User';
                            
                            // Merge guest items into DB
                            const guestCartToMerge = guestCart.map(item => ({
                                ...item,
                                ledcode: currentLoginId,
                                ledname: currentLoginName,
                                ledemail: localStorage.getItem('loginEmail') || ''
                            }));

                            // Clear guest cart BEFORE merge API call to prevent re-triggering while in flight
                            localStorage.removeItem('guestCart');

                            const mergeRes = await fetch(`${apiBaseUrl}/cart/add/BLACKBATON_2526`, {
                                method: 'POST',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify(guestCartToMerge),
                            });

                            if (mergeRes.ok) {
                                // Guest cart already removed above
                                const refreshedRes = await fetch(
                                    `${apiBaseUrl}/cart/items/BLACKBATON_2526/${ledCodeOrUserId}`
                                );
                                const refreshedData = await refreshedRes.json();
                                dbItems = (refreshedData.success && refreshedData.items) ? refreshedData.items : [];
                            } else {
                                // If merge failed, we might want to restore the guest cart or handle error
                                console.error('Failed to merge guest cart into DB');
                            }
                        } catch (mergeErr) {
                            console.error('Error merging guest cart:', mergeErr);
                        }
                    }
                    finalItems = dbItems;
                }

                setCartItems(finalItems);

                if (finalItems.length > 0) {
                    // Fetch product details for each item
                    const details = {};
                    for (const item of finalItems) {
                        const productInfo = await fetchProductDetails(item.uniqueCode);
                        if (productInfo) {
                            details[item.uniqueCode] = {
                                color: productInfo.Color,
                                size: productInfo.Size,
                            };
                        }
                    }
                    setProductDetails(details);
                }
            } catch (error) {
                setError(error.message);
                setCartItems([]);
            } finally {
                setLoading(false);
            }
        };

        fetchCartItems();
    }, [LedCode, userId, apiBaseUrl]);

    const handleQuantityChange = async (identifier, newQuantity) => {
        try {
            // Prevent quantity from going below 1
            if (newQuantity < 1) {
                alert('Quantity cannot be less than 1');
                return;
            }

            // Find the item in the cartItems array using sino or uniqueCode
            const itemToUpdate = cartItems.find((item) => item.sino === identifier || item.uniqueCode === identifier);
            
            if (!itemToUpdate) {
                console.error("Item not found for identifier:", identifier);
                return;
            }

            // Calculate the difference between the new quantity and the current quantity
            const quantityDifference = newQuantity - itemToUpdate.quantity;

            if (!LedCode && !userId) {
                // Guest User update
                const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
                const updatedGuestCart = guestCart.map(item =>
                    item.uniqueCode === itemToUpdate.uniqueCode
                        ? { ...item, quantity: newQuantity }
                        : item
                );
                localStorage.setItem('guestCart', JSON.stringify(updatedGuestCart));
                setCartItems(updatedGuestCart);
                return;
            }

            // Send API request to update quantity in the backend
            const response = await fetch(`${apiBaseUrl}/cart/add/BLACKBATON_2526`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify([{
                    itemId: itemToUpdate.itemId,
                    uniqueCode: itemToUpdate.uniqueCode,
                    itemName: itemToUpdate.itemName,
                    itemPrice: itemToUpdate.itemPrice,
                    quantity: quantityDifference, // Send the difference, not the new quantity
                    ledname: itemToUpdate.ledname,
                    ledcode: itemToUpdate.ledcode,
                    ledemail: itemToUpdate.ledemail,
                }]),
            });

            if (!response.ok) {
                throw new Error('Failed to update quantity');
            }

            const data = await response.json();
            //('Quantity updated successfully:', data);

            // Update the cartItems state only after the API call succeeds
            const updatedCartItems = cartItems.map((item) =>
                (item.sino === identifier || item.uniqueCode === identifier) ? { ...item, quantity: newQuantity } : item
            );
            setCartItems(updatedCartItems);
        } catch (error) {
            console.error('Error updating quantity:', error);
            alert('Failed to update quantity. Please try again.');
        }
    };

    const [modifiedColors, setModifiedColors] = useState([])

    // console.log(modifiedColors,'modifiedColors');

    useEffect(() => {
        const fetchModfiedColors = async () => {
            try {
                const response = await fetch(`${apiBaseUrl}/getAllModifiedColors/BLACKBATON_2526`);
                const data = await response.json();
                // console.log(data,'data');

                const modifiedColors = data.reduce((acc, item) => {
                    acc[item.db_color] = {
                        name: item.md_color?.toUpperCase() || '',
                        hex: item.hex || ''
                    };
                    return acc;
                }, {});

                setModifiedColors(modifiedColors);
            } catch (error) {
                console.error('Error fetching color and size data:', error);
            }
        };
        fetchModfiedColors()
    }, [])

    useEffect(() => {
        const fetchAddress = async () => {


            try {
                const ledCodeOrUserId = LedCode || userId;

                //("Fetching Cart Items for:", ledCodeOrUserId);
                const response = await fetch(`${apiBaseUrl}/user/getAddresses/BLACKBATON_2526/${ledCodeOrUserId}`);
                const data = await response.json();

                if (data.success && data.data.length > 0) {
                    // Get only active addresses
                    const activeAddress = data.data.find(addr => addr.isActive);

                    const res = await fetch(`${apiBaseUrl}/delhivery-pincode/${activeAddress.pincode}`);
                    const result = await res.json();

                    let isPrepaid = false;
                    let isCod = false;

                    if (result.success) {
                        const pinInfo = result.data?.delivery_codes?.[0]?.postal_code;
                        isPrepaid = pinInfo?.pre_paid === "Y";
                        isCod = pinInfo?.cod === "Y";
                    }

                    // Add pre_paid field to address state
                    setAddress({
                        ...activeAddress,
                        pre_paid: isPrepaid,
                        cod: isCod
                    });

                }
            } catch (error) {
                console.error('Error fetching address:', error);
            }
        };

        fetchAddress();
    }, [LedCode, apiBaseUrl, userId]);

    const addresspage = () => {
        navigate('/address');
    };

    const wishlistpage = () => {
        navigate('/wishlist')
    }



    // if (loading) {
    //     return <div>Loading...</div>;
    // }

    if (error) {
        return <div>Error: {error}</div>;
    }

    // const handleSendToWhatsapp = async (url, payload, number) => {
    //     const requestId = Date.now() + Math.random();
    //     try {
    //         console.log(`Sending request ${requestId} to ${url} with payload:`, payload);
    //         const response = await fetch(url, {
    //             method: "POST",
    //             headers: { "Content-Type": "application/json" },
    //             body: JSON.stringify({ ...payload, requestId }),
    //         });
    //         const data = await response.json();
    //         console.log(`Response for request ${requestId} from ${url} for ${number}:`, {
    //             status: response.status,
    //             data,
    //         });
    //         return {
    //             to: number,
    //             success: response.ok && data.success !== false,
    //             message:
    //                 data.message || (response.ok ? "Message sent successfully" : `Failed: ${response.statusText}`),
    //             type,
    //         };
    //     } catch (error) {
    //         console.error(`Error for request ${requestId} sending to ${url} for ${number}:`, error);
    //         return {
    //             to: number,
    //             success: false,
    //             message: error.message || `Network error sending to ${number}`,
    //             type,
    //         };
    //     }
    // };

    // console.log(cartItems, 'cartItems');

    function encodeBase64(text) {
        return btoa(text);
    }


    const handleSubmitWhatsapp = async () => {

        try {


            const ledName = address.name || "Customer";
            const now = new Date();

            const cDate = now.toLocaleDateString("en-GB");
            const cTime = now.toLocaleTimeString("en-US", {
                hour: "2-digit",
                minute: "2-digit",
                hour12: true
            });

            const groupedData = Object.values(
                cartItems.reduce((acc, item) => {

                    const color = modifiedColors[productDetails[item.uniqueCode]?.color]?.name || [];
                    const modifiedColor = modifiedColors[color]?.name;
                    const size = productDetails[item.uniqueCode]?.size || "N/A";

                    // If itemName is not present, create base object
                    if (!acc[item.itemName]) {
                        acc[item.itemName] = {
                            itemId: item.itemId,
                            itemName: item.itemName,
                            itemPrice: item.itemPrice,
                            size: {}   //  create size object
                        };
                    }

                    // If size group does not exist, create it
                    if (!acc[item.itemName].size[size]) {
                        acc[item.itemName].size[size] = [];
                    }

                    // Push item details under correct size
                    acc[item.itemName].size[size].push({
                        quantity: item.quantity,
                        sino: item.sino,
                        uniqueCode: item.uniqueCode,
                        color: modifiedColor || color
                    });

                    return acc;
                }, {})
            );


            let message = `Ⓑ *𝗕𝗟𝗔𝗖𝗞𝗕𝗔𝗧𝗢𝗡*\n✔️ Order Confirmed\n\nDate: ${cDate} ${cTime}\n`;

            if (address.name) {
                message += `Customer : *${ledName}*\n`;
            }
            if (address.mobile) {
                message += `Mobile : *${address.mobile}*\n`;
            }
            if (address.address) {
                message += `Address : ${address.address}\n`;
            }

            let totalAmount = 0; // GRAND TOTAL

            groupedData.forEach(itemGroup => {
                let itemTotalAmount = 0; //  TOTAL FOR EACH ITEM NAME

                const link = `www.blackbaton.com/${shortEncrypt('fullimage')}?I=${encodeBase64(String(itemGroup.itemId))}&N=${encodeBase64(itemGroup.itemName)}`

                message += '\n⤷ ';
                message += '`';
                message += `${link}`;
                message += '`';
                message += '\n';
                message += `*${itemGroup.itemName}*\n`;

                // STEP 1: Build color-size map
                const colorSizeMap = {};

                Object.entries(itemGroup.size).forEach(([size, items]) => {
                    items.forEach(d => {
                        const color = d.color || "N/A";

                        if (!colorSizeMap[color]) {
                            colorSizeMap[color] = {};
                        }

                        if (!colorSizeMap[color][size]) {
                            colorSizeMap[color][size] = 0;
                        }

                        colorSizeMap[color][size] += d.quantity;
                    });
                });

                // STEP 2: Build WhatsApp lines (color : sizes)
                Object.entries(colorSizeMap).forEach(([color, sizes]) => {

                    const sizeString = Object.entries(sizes)
                        .map(([size, qty]) => {

                            const lineTotal = itemGroup.itemPrice * qty;

                            //  add to item total
                            itemTotalAmount += lineTotal;

                            //  add to grand total
                            totalAmount += lineTotal;

                            return `${size} - ${qty}`;   //  FIXED (you forgot return)
                        })
                        .join(', ');

                    message += `* ${color} : ${sizeString}\n`;
                });

                // Show item total
                message += `*Total :* ₹${itemTotalAmount.toFixed(2)}\n`;
            });

            message += `\n----------------------------\n💰 *Grand Total : ₹${totalAmount.toFixed(2)}*`;

            // console.log(address.mobile, 'address.mobile');
            const normalizeMobile = (num) => {
                if (!num) return "";

                // Convert to string & trim spaces
                num = String(num).trim();

                // Remove all non-digits (if any)
                num = num.replace(/\D/g, "");

                // If number starts with 0 → remove that 0
                if (num.startsWith("0")) {
                    num = num.substring(1);
                }

                // Now ensure it starts with 91
                if (!num.startsWith("91")) {
                    num = "91" + num;
                }

                return num;
            };

            const finalMobile = normalizeMobile(address.mobile);

            // console.log(finalMobile, 'finalMobile');



            try {
                const response = await axios.post(`${apiWhatsappUrl}/send-message`, {
                    // userId: 'BLACKBATON',
                    appkey: "98efaeca-73f7-4340-8745-1647982a0ba8",
                    authkey: "10b2f32068003fd32a0878f57a8a0b2e",
                    to: finalMobile,
                    message: message
                });

            } catch (error) {
                console.error('Error sending WhatsApp message:', error);
                // alert('An error occurred while sending the message. Please try again.');
            } finally {
                try {
                    const response = await axios.post(`${apiWhatsappUrl}/send-group`, {
                        // userId: 'BLACKBATON',
                        appkey: "98efaeca-73f7-4340-8745-1647982a0ba8",
                        authkey: "10b2f32068003fd32a0878f57a8a0b2e",
                        groupName: "Website orders details",
                        // groupName: "Test",
                        message: message
                    });

                } catch (error) {
                    console.error('Error sending WhatsApp message:', error);
                    // alert('An error occurred while sending the message. Please try again.');
                }
            }



        } catch (err) {
            console.error(err);
        }
    };




    const handleModalLogin = async (e) => {
        if (e) e.preventDefault();
        setLoginError("");
        try {
            if (!loginEmail || !loginPassword) {
                setLoginError('Please enter both email/mobile and password');
                return;
            }

            const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            const mobilePattern = /^\d{10}$/;
            let isInput = '';

            if (emailPattern.test(loginEmail)) {
                isInput = 'email';
            } else if (mobilePattern.test(loginEmail)) {
                isInput = 'mobile';
            } else {
                setLoginError('Please enter a valid email or 10-digit mobile number');
                return;
            }

            const response = await axios.post(`${apiBaseUrl}/user/login/BLACKBATON_2526`, {
                identifier: loginEmail,
                password: loginPassword,
                type: isInput
            });

            if (response.data.success) {
                const userData = response.data.user;
                localStorage.setItem('loginId', userData.id);
                localStorage.setItem('i_a', encrypt(String(userData.isAdmin)));
                localStorage.setItem('loginName', userData.full_name);
                localStorage.setItem('loginEmail', userData.email || '');
                localStorage.setItem('loginMobile', userData.mobile || '');
                localStorage.setItem('LedCode', userData.id);

                if (rememberMe) {
                    localStorage.setItem('rememberedIdentifier', loginEmail);
                } else {
                    localStorage.removeItem('rememberedIdentifier');
                }

                dispatch(setUser({
                    id: userData.id,
                    rememberMe,
                    isAdmin: encrypt(String(userData.isAdmin))
                }));

                setIsLoginModalOpen(false);
                toast.success("Logged in successfully!");

                // Reload to refresh states properly
                window.location.reload();
            } else {
                setLoginError(response.data.error || 'Invalid credentials');
            }
        } catch (err) {
            console.error('Login error:', err);
            setLoginError(err.response?.data?.error || 'An error occurred while logging in');
        }
    };

    const handlePlaceOrder = async () => {
        if (isProcessing) return;
        setIsProcessing(true);

        // toast.error("Coming soon!");
        // return

        if (cartItems.length === 0) {
            toast.error("No items in cart");
            setIsProcessing(false);
            return;
        }

        if (!LedCode && !userId) {
            setIsLoginModalOpen(true);
            setIsProcessing(false);
            return;
        }

        if (!address) {
            setAddError(true);

            setTimeout(() => {
                setAddError(false);
            }, 1000);

            toast.error("Please add an address to continue");
            setIsProcessing(false);
            return;
        }

        const requiredFields = [
            "name",
            "mobile",
            "address",
            "city",
            "area",
            "pincode",
            "street",
            "locality",
            "landmark",
            "buildingName",
            "houseNo",
            "district",
            "state",
        ];

        const isIncomplete = requiredFields.some(
            key => address[key] === null || address[key] === undefined || address[key] === ""
        );

        if (isIncomplete) {

            setAddError(true);

            setTimeout(() => {
                setAddError(false);
            }, 1000);
            toast.error("Please complete the address details.");
            setIsProcessing(false);
            return;
        }


        if (!/^[6-9]\d{9}$/.test(address.mobile)) {
            setAddError(true);

            setTimeout(() => {
                setAddError(false);
            }, 1000);

            toast.error("Enter a valid 10-digit mobile number");
            setIsProcessing(false);
            return;
        }

        if (!/^\d{6}$/.test(address.pincode)) {
            setAddError(true);

            setTimeout(() => {
                setAddError(false);
            }, 1000);

            toast.error("Enter a valid 6-digit pincode");
            setIsProcessing(false);
            return;
        }


        // check count > 2
        const duplicateFields = [
            "area",
            "buildingName",
            "city",
            "houseNo",
            "landmark",
            "locality"
        ];

        // Collect normalized (trimmed + lowercase) values
        const values = duplicateFields
            .map(key => address[key])
            .filter(val => val && val.trim() !== "")
            .map(val => val.trim().toLowerCase());

        // Count occurrences
        const frequency = values.reduce((acc, val) => {
            acc[val] = (acc[val] || 0) + 1;
            return acc;
        }, {});

        // Check if any value occurs more than 2 times
        const hasExcessiveDuplicates = Object.values(frequency).some(count => count > 2);

        if (hasExcessiveDuplicates) {
            setAddError(true);

            setTimeout(() => {
                setAddError(false);
            }, 1000);

            toast.error("Address fields contain repeated values. Please refine your address. ");
            setIsProcessing(false);
            return;
        }



        if (!address?.pre_paid) {
            toast.error("Prepaid delivery is not available for this PIN code. Please choose a different address.");
            setIsProcessing(false);
            return;
        }

        // Calculate total amount
        const totalAmount = cartItems.reduce(
            (total, item) => total + item.itemPrice * item.quantity,
            0
        );

        // Step 1: Create a Razorpay order on the backend
        try {
            const response = await fetch(`${apiRazorpayUrl}/create-order`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    amount: totalAmount,
                    currency: "INR",
                    receipt: `order_${Date.now()}`,
                }),
            });

            const order = await response.json();


            const options = {
                key: "rzp_live_SVm7giDNCkbN66",
                // key: "rzp_test_SIjECOcUjoYoac",
                amount: order.amount,
                currency: order.currency,
                order_id: order.id,
                name: "BLACK BATON",
                description: "Payment for your order",

                handler: async (response) => {

                    const verifyRes = await fetch(`${apiRazorpayUrl}/verify-payment`, {
                        method: "POST",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_signature: response.razorpay_signature
                        })
                    });

                    const result = await verifyRes.json();

                    if (result.valid) {
                        toast.success("Payment Verified ✅");
                        await placeOrder();
                    } else {
                        toast.error("Payment verification failed ❌");
                        setIsProcessing(false);
                    }
                },

                prefill: {
                    name: address.name,
                    email: address.email,
                    contact: address.mobile,
                },
                theme: { color: "#F37254" },
                modal: {
                    ondismiss: () => {
                        setIsProcessing(false);
                    }
                }
            };



            const rzp = new window.Razorpay(options); // Use global Razorpay object
            rzp.open();

            // Handle payment failure
            rzp.on("payment.failed", async (response) => {
                console.error("Payment failed:", response);
                toast.error("Payment failed, but order will still be processed.");
                setIsProcessing(false);
            });
        } catch (error) {
            console.error("Error creating Razorpay order:", error);
            toast.error("Failed to initiate payment. Please try again.");
            setIsProcessing(false);
        }
    };

    // Function to place the order
    const placeOrder = async () => {
        if (isProcessing && !window.Razorpay) { // If called directly from button, check isProcessing
            if (isProcessing) return;
        }
        setIsProcessing(true);

        if (!address) {
            toast.error("Please add an address to continue");
            setIsProcessing(false);
            return;
        }

        if (!address?.pre_paid) {
            toast.error("Prepaid delivery is not available for this PIN code. Please choose a different address.");
            setIsProcessing(false);
            return;
        }

        const model = "";

        // Format the items array manually as a string with escaped quotes
        const itemsString = cartItems
            .map(
                (item) =>
                    `{\\"id\\":${item.itemId},\\"name\\":\\"${item.itemName}\\",\\"model\\":\\"${model}\\",\\"dp\\":0,\\"mrp\\":${item.itemPrice},\\"quantity\\":${item.quantity},\\"uniqueCode\\":${item.uniqueCode}}`
            )
            .join(",");

        const currentDate = new Date().toLocaleDateString("en-GB").split("/").reverse().join("-");
        const requestBody = `{"date":"${currentDate}","id":"${LedCode}","contact":"${address.mobile}","items":"[${itemsString}]"}`;

        // console.log(requestBody,'requestBody');

        try {
            // Send the data to the API
            const response = await fetch(`${apiBaseUrl}/orderAdd/BLACKBATON_2526`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: requestBody,
            });

            if (!response.ok) {
                throw new Error("Failed to place order");
            }

            const result = await response.json();

            const orderId = result?.entryNo;

            // console.log(orderId,'orderId');


            const today = new Date().toISOString().split('T')[0];


            const shipmentResponse = await fetch(`${apiBaseUrl}/create-delhivery-shipment/BLACKBATON_2526`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    orderId,
                    date: today,
                    customerAddress: {
                        name: address?.name,
                        address: address?.address,
                        city: address?.city,
                        district: address?.district,
                        state: address?.state,
                        pincode: address?.pincode,
                        mobile: address?.mobile,
                        email: address?.email || "",
                        type: address?.addressType
                    },
                    cartItems
                }),
            });

            const shipmentResult = await shipmentResponse.json();

            // console.log(shipmentResult, "shipmentResult");

            if (!shipmentResult.success) {
                // console.warn("Shipment issue:", shipmentResult.message);
            } else if (!shipmentResult.awb) {
                // console.log("Shipment created but AWB pending");
            } else {
                // console.log("AWB:", shipmentResult.awb);
            }

            handleSubmitWhatsapp()

            // Clear the cart after successful order placement
            const clearCartResponse = await fetch(`${apiBaseUrl}/cart/clear/BLACKBATON_2526/${LedCode || userId}`, {
                method: "DELETE",
            });

            if (!clearCartResponse.ok) {
                throw new Error("Failed to clear cart");
            }

            await clearCartResponse.json();
            //("Cart cleared successfully:", clearCartResult);

            // Update the UI by resetting the cart items
            setCartItems([]);

            // Set orderPlaced to true to show the OrderSuccess component
            setOrderPlaced(true);
        } catch (error) {
            console.error("Error placing order:", error);
            toast.error("Failed to place order. Please try again.");
        } finally {
            setIsProcessing(false);
        }
    };

    // const placeOrder = async () => {
    //     if (isProcessing && !window.Razorpay) {
    //         if (isProcessing) return;
    //     }

    //     setIsProcessing(true);

    //     console.log("===== PLACE ORDER START =====");

    //     if (!address) {
    //         console.error("Address missing");
    //         toast.error("Please add an address to continue");
    //         setIsProcessing(false);
    //         return;
    //     }

    //     if (!address?.pre_paid) {
    //         console.error("Pincode not prepaid enabled");
    //         toast.error("Prepaid delivery is not available for this PIN code.");
    //         setIsProcessing(false);
    //         return;
    //     }

    //     try {

    //         const model = "";

    //         const itemsArray = cartItems.map((item) => ({
    //             id: item.itemId,
    //             name: item.itemName,
    //             model: model,
    //             dp: 0,
    //             mrp: item.itemPrice,
    //             quantity: item.quantity,
    //             uniqueCode: item.uniqueCode
    //         }));

    //         console.log("Items Array:", itemsArray);

    //         const currentDate = new Date()
    //             .toLocaleDateString("en-GB")
    //             .split("/")
    //             .reverse()
    //             .join("-");

    //         const requestBody = {
    //             date: currentDate,
    //             id: String(LedCode),
    //             contact: address.mobile,
    //             items: JSON.stringify(itemsArray)
    //         };

    //         console.log("Request Body Object:", requestBody);
    //         console.log("Request Body JSON:", JSON.stringify(requestBody));

    //         console.log("API URL:", `${apiBaseUrl}/orderAdd/BLACKBATON_2526`);

    //         const response = await fetch(`${apiBaseUrl}/orderAdd/BLACKBATON_2526`, {
    //             method: "POST",
    //             headers: {
    //                 "Content-Type": "application/json",
    //             },
    //             body: JSON.stringify(requestBody),
    //         });

    //         console.log("Response Status:", response.status);

    //         const responseText = await response.text();

    //         console.log("Raw Server Response:", responseText);

    //         if (!response.ok) {
    //             console.error("Server returned error:", responseText);
    //             throw new Error(responseText || "Order API failed");
    //         }

    //         let result;

    //         try {
    //             result = JSON.parse(responseText);
    //         } catch (e) {
    //             console.error("JSON parse error:", e);
    //             throw new Error("Invalid JSON returned from server");
    //         }

    //         console.log("Parsed Order Response:", result);

    //         const orderId = result?.entryNo;

    //         console.log("Generated Order ID:", orderId);

    //         const today = new Date().toISOString().split("T")[0];

    //         console.log("Creating Delhivery shipment...");

    //         const shipmentResponse = await fetch(
    //             `${apiBaseUrl}/create-delhivery-shipment/BLACKBATON_2526`,
    //             {
    //                 method: "POST",
    //                 headers: {
    //                     "Content-Type": "application/json"
    //                 },
    //                 body: JSON.stringify({
    //                     orderId,
    //                     date: today,
    //                     customerAddress: {
    //                         name: address?.name,
    //                         address: address?.address,
    //                         city: address?.city,
    //                         district: address?.district,
    //                         state: address?.state,
    //                         pincode: address?.pincode,
    //                         mobile: address?.mobile,
    //                         email: address?.email || "",
    //                         type: address?.addressType
    //                     },
    //                     cartItems
    //                 })
    //             }
    //         );

    //         console.log("Shipment Response Status:", shipmentResponse.status);

    //         const shipmentText = await shipmentResponse.text();

    //         console.log("Shipment Raw Response:", shipmentText);

    //         let shipmentResult;

    //         try {
    //             shipmentResult = JSON.parse(shipmentText);
    //         } catch (e) {
    //             console.error("Shipment JSON parse error:", e);
    //         }

    //         console.log("Shipment Result:", shipmentResult);

    //         if (!shipmentResponse.ok || !shipmentResult?.success) {
    //             console.warn("Shipment creation failed:", shipmentResult?.message);
    //         }

    //         console.log("Sending WhatsApp message...");
    //         handleSubmitWhatsapp();

    //         console.log("Clearing cart...");

    //         const clearCartResponse = await fetch(
    //             `${apiBaseUrl}/cart/clear/BLACKBATON_2526/${LedCode || userId}`,
    //             {
    //                 method: "DELETE"
    //             }
    //         );

    //         console.log("Clear Cart Status:", clearCartResponse.status);

    //         const clearCartText = await clearCartResponse.text();

    //         console.log("Clear Cart Response:", clearCartText);

    //         setCartItems([]);

    //         setOrderPlaced(true);

    //         console.log("===== ORDER SUCCESS =====");

    //     } catch (error) {

    //         console.error("===== ORDER FAILED =====");
    //         console.error("Error details:", error);

    //         toast.error("Failed to place order. Please try again.");

    //     } finally {
    //         setIsProcessing(false);
    //     }
    // };

    const handleDeleteItem = async (itemId, ledcode, uniqueCode) => {
        if (!LedCode && !userId) {
            // Guest User delete
            const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
            const updatedGuestCart = guestCart.filter(item => item.uniqueCode !== uniqueCode);
            localStorage.setItem('guestCart', JSON.stringify(updatedGuestCart));
            setCartItems(updatedGuestCart);
            toast.success('Item deleted successfully');
            return;
        }

        try {
            const response = await fetch(`${apiBaseUrl}/cart/item/BLACKBATON_2526/${itemId}/${ledcode}/${uniqueCode}`, {
                method: 'DELETE',
            });

            const data = await response.json();

            if (response.ok) {
                alert('Item deleted successfully');
                // Refresh the cart or remove the item from state
                setCartItems((prevItems) => prevItems.filter(item => item.uniqueCode !== uniqueCode));
            } else {
                alert(data.message || 'Failed to delete item');
            }
        } catch (error) {
            console.error('Error deleting item:', error);
            alert('Error deleting item');
        }
    };




    return (
        <div className='min-h-screen flex flex-col' onClick={() => setShowDropdown(false)}>
            {isMobile ? <NavbarMob /> : <Navbar />}
            {/* Order Success Modal */}
            {orderPlaced && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <OrderSuccess onClose={() => setOrderPlaced(false)} />
                </div>
            )}
            {cartItems.length > 0 && (
                < div
                    className={`h-[56px] ${isProcessing ? 'bg-gray-500 cursor-not-allowed' : 'bg-[black] cursor-pointer'} justify-center lg:hidden flex items-center fixed bottom-0 left-0 w-full text-base font-[600] font-montserrat text-[white]`}
                    // onClick={!isProcessing ? placeOrder : null}
                    onClick={!isProcessing ? handlePlaceOrder : null}
                >
                    {isProcessing ? 'Processing...' : (!LedCode && !userId) ? 'Login' : 'Place Order'}
                </div>
            )}
            <div className='w-full h-auto lg:px-12 px-3 py-6 flex flex-col lg:gap-12 gap-6 lg:mt-[175px] mt-[60px] lg:pb-12 pb-6'>
                <span className='lg:text-2xl text-lg font-[700] font-montserrat text-left'>Shopping Bag</span>
                <div className='w-full flex lg:flex-row flex-col gap-8 lg:pb-12 pb-6'>
                    <div className='lg:w-[70%] w-full h-auto flex flex-col gap-3'>
                        <div className={`rounded-[5px] lg:h-[58px] h-auto border-2 ${addError ? 'border-[#eb0000]' : 'border-[#EAEAEC]'} justify-between flex lg:flex-row flex-row lg:items-center items-start lg:py-0 py-3 lg:px-5 px-1 lg:gap-0 gap-3`}>
                            <span className='lg:text-sm text-xs font-[400] font-montserrat text-left'>
                                Deliver to:&nbsp;&nbsp;&nbsp;
                                {address ? `${address.name}, ${address.address}, ${address.city}` : 'No address Selected'}
                            </span>
                            <span
                                className={`lg:w-[10%] w-[30%] h-[30px] border-2 ${!address ? 'border-[red]' : 'border-[black]'
                                    } rounded-[3.51px] flex justify-center items-center lg:text-sm text-xs font-[400] font-montserrat cursor-pointer`}
                                onClick={addresspage}
                            >
                                Add
                            </span>
                        </div>

                        {cartItems.length === 0 ? (
                            <div className="flex flex-col items-center justify-center h-[300px] bg-gray-100 rounded-md shadow-md p-6">
                                <span className="text-lg font-semibold text-gray-700">Your cart is empty</span>
                                <p className="text-sm text-gray-500">Add items to your cart to see them here.</p>
                            </div>
                        ) : (
                            cartItems.map((item, idx) => {

                                const color = modifiedColors[productDetails[item.uniqueCode]?.color]?.name || [];
                                const code = `${item.itemId}_${color}`
                                const modifiedColor = modifiedColors[color]?.name

                                return (
                                    <div key={idx} className='rounded-[5px] h-auto lg:px-5 px-1 py-5 border-2 border-[#EAEAEC] justify-between flex lg:flex-row flex-col'>
                                        <div className='flex flex-row h-[115px] gap-5 items-center'>
                                            <div className='h-full w-[90px] bg-[white] rounded-[5px] p-3'>
                                                <img
                                                    src={`${apiLocalUrl}/uploads/${code}.webp`}
                                                    alt={item.itemName}
                                                    style={{ width: '100%', height: '100%', mixBlendMode: 'multiply' }}
                                                />
                                            </div>
                                            <div className='h-full flex flex-col gap-2'>
                                                <span className='lg:text-base text-left text-sm font-[600] font-montserrat'>{item.itemName} [{modifiedColor || color}]</span>
                                                <span className='text-sm font-[400] font-montserrat text-left'>Qty: {item.quantity}</span>
                                                <span className='text-lg font-[600] font-montserrat text-left'>₹{item.itemPrice}</span>
                                                <span className='text-lg font-[600] font-montserrat text-left'>

                                                    <div
                                                        style={{
                                                            display: 'inline-block',
                                                            width: '16px',
                                                            height: '16px',
                                                            borderRadius: '50%',
                                                            backgroundColor: color || 'transparent',
                                                            border: color ? '1px solid #ccc' : 'none',

                                                            verticalAlign: 'middle',
                                                        }}
                                                    />
                                                    &nbsp;  {productDetails[item.uniqueCode]?.size || 'N/A'}
                                                </span>
                                            </div>
                                        </div>
                                        <div className='flex flex-col gap-3 items-end '>
                                            {/* <span className='text-sm font-[400] font-montserrat'>Delivery by Sat Dec 28</span> */}
                                            <div className='w-max p-2 h-[36px] border-2 border-[#EAEAEC] rounded-[32px] flex flex-row justify-center items-center gap-3 '>
                                                <span
                                                    className='p-2 font-[500] text-sm font-montserrat cursor-pointer'
                                                    onClick={() => handleQuantityChange(item.sino || item.uniqueCode, item.quantity - 1)}
                                                >
                                                    -
                                                </span>
                                                <span className='font-[500] text-xl font-montserrat'>{item.quantity}</span>
                                                <span
                                                    className='p-2 font-[500] text-sm font-montserrat cursor-pointer'
                                                    onClick={() => handleQuantityChange(item.sino || item.uniqueCode, item.quantity + 1)}
                                                >
                                                    +
                                                </span>

                                            </div>

                                            <img
                                                src={deleteicon}
                                                alt="deleteicon"
                                                className='cursor-pointer'
                                                onClick={() => handleDeleteItem(item.itemId, item.ledcode, item.uniqueCode)}
                                            />


                                        </div>
                                    </div>
                                )
                            })
                        )}

                        <div className='rounded-[5px] h-[60px] border-2 border-[#EAEAEC] justify-between flex items-center lg:px-5 px-1 cursor-pointer' onClick={wishlistpage}>
                            <span className='text-sm font-[400] font-montserrat'>Add More From Wishlist</span>
                        </div>

                        {cartItems.length > 0 && (
                            <div className='rounded-[5px] h-[100px] border-2 border-[#EAEAEC] justify-end lg:flex hidden items-center lg:px-5 px-1'>
                                <button
                                    className={`h-[50px] w-[30%] ${isProcessing ? 'bg-gray-500 cursor-not-allowed' : 'bg-[black] cursor-pointer'} rounded-[5px] flex justify-center items-center text-base font-[500] font-montserrat text-[white]`}
                                    // onClick={placeOrder}                                    
                                    onClick={handlePlaceOrder}

                                    disabled={isProcessing}
                                >
                                    {isProcessing ? 'Processing...' : (!LedCode && !userId) ? 'Login' : 'Place Order'}
                                </button>
                            </div>
                        )}
                    </div>

                    <div className='lg:w-[30%] w-full h-[321px] flex flex-col rounded-[2px] border-2 border-[#EAEAEC] lg:mb-0 mb-[25%]'>
                        <div className='w-full h-[18%] border-b-2 border-[#EAEAEC] px-3 flex justify-between items-center text-base font-[600] font-montserrat'>
                            Price Details
                        </div>
                        <div className='w-full h-[82%] flex flex-col px-3 gap-5'>
                            <ul className='border-2 border-black mt-5 text-[#F0F0F0]' />
                            <div className='flex flex-col gap-5 w-full'>
                                <div className='w-full flex justify-between'>
                                    <span className='text-base font-[400] font-montserrat'>Price ({cartItems.length} items)</span>
                                    <span className='text-base font-[600] font-montserrat'>
                                        ₹{cartItems.reduce((total, item) => total + item.itemPrice * item.quantity, 0)}
                                    </span>
                                </div>
                                <div className='w-full flex justify-between'>
                                    <span className='text-base font-[400] font-montserrat'>Discount</span>
                                    <span className='text-base font-[600] font-montserrat'></span>
                                </div>
                                <div className='w-full flex justify-between'>
                                    <span className='text-base font-[400] font-montserrat'>Delivery Charges</span>
                                    <span className='text-base font-[600] font-montserrat'>₹00.00</span>
                                </div>
                            </div>
                            <ul className='border-b-2 border-black border-dashed' />
                            <div className='w-full flex justify-between'>
                                <span className='text-base font-[600] font-montserrat'>Total Amount</span>
                                <span className='text-base font-[600] font-montserrat'>
                                    ₹{cartItems.reduce((total, item) => total + item.itemPrice * item.quantity, 0)}
                                </span>
                            </div>
                            <ul className='border-b-2 border-black border-dashed' />
                        </div>
                    </div>
                </div>
            </div>
            <div className='lg:flex hidden'>{isMobile ? <FooterMob /> : <Footer />}</div>
            <ToastContainer position="top-right" autoClose={3000} />

            {/* Login Modal */}
            {isLoginModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[100] backdrop-blur-sm p-4">
                    <div className="bg-white rounded-3xl w-full max-w-md overflow-hidden shadow-lg animate-fade-in">
                        <div className="p-8">
                            <div className="flex justify-between items-center mb-6">
                                <h2 className="text-3xl font-bold font-montserrat">Login to Checkout</h2>
                                <button
                                    onClick={() => setIsLoginModalOpen(false)}
                                    className="text-gray-400 hover:text-black transition-colors text-2xl"
                                >
                                    ×
                                </button>
                            </div>
                            <p className="text-gray-600 mb-8 font-montserrat">Please log in to your account to proceed with your order.</p>

                            <form onSubmit={handleModalLogin} className="space-y-6">
                                <div className="space-y-2">
                                    <label className="text-sm font-semibold font-montserrat block">Email / Mobile</label>
                                    <input
                                        type="text"
                                        className="w-full h-12 rounded-xl px-4 bg-gray-100 focus:ring-2 focus:ring-black outline-none transition-all"
                                        placeholder="Enter your email or mobile"
                                        value={loginEmail}
                                        onChange={(e) => setLoginEmail(e.target.value)}
                                    />
                                </div>

                                <div className="space-y-2">
                                    <label className="text-sm font-semibold font-montserrat block">Password</label>
                                    <div className="relative">
                                        <input
                                            type={showPassword ? "text" : "password"}
                                            className="w-full h-12 rounded-xl px-4 bg-gray-100 focus:ring-2 focus:ring-black outline-none transition-all"
                                            placeholder="Enter your password"
                                            value={loginPassword}
                                            onChange={(e) => setLoginPassword(e.target.value)}
                                        />
                                        <button
                                            type="button"
                                            className="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-black"
                                            onClick={() => setShowPassword(!showPassword)}
                                        >
                                            {showPassword ? <FaEyeSlash /> : <FaEye />}
                                        </button>
                                    </div>
                                </div>

                                <div className="flex items-center gap-2">
                                    <input
                                        type="checkbox"
                                        id="rememberModal"
                                        className="w-4 h-4 rounded border-gray-300 text-black focus:ring-black"
                                        checked={rememberMe}
                                        onChange={() => setRememberMe(!rememberMe)}
                                    />
                                    <label htmlFor="rememberModal" className="text-sm font-medium font-montserrat cursor-pointer">
                                        Remember me
                                    </label>
                                </div>

                                {loginError && (
                                    <p className="text-red-500 text-sm font-medium bg-red-50 p-3 rounded-lg border border-red-100 animate-pulse">
                                        {loginError}
                                    </p>
                                )}

                                <button
                                    type="submit"
                                    className="w-full h-14 bg-black text-white rounded-xl font-bold font-montserrat hover:bg-gray-800 transition-all transform active:scale-95 shadow-lg flex items-center justify-center gap-2"
                                    onClick={handleModalLogin}
                                >
                                    Proceed to Checkout
                                </button>
                            </form>

                            <div className="mt-8 pt-6 border-t border-gray-100 text-center">
                                <p className="text-sm text-gray-500">
                                    Don't have an account?{' '}
                                    <button
                                        onClick={() => navigate('/signup')}
                                        className="text-black font-bold underline hover:text-red-600 transition-colors"
                                    >
                                        Register Here
                                    </button>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div >
    );
}

export default Cart;